module.exports = __webpack_public_path__ + "static/media/3DPPA7.e9bdb2b5.jpg";